<template>
    <div class="col-12 pt-3">
        <transition name="fade" mode="out-in">
            <ContentOrLoading>
                <template v-if="evento">
                    
                    <div class="col-12 mb-3">
                        <label for="companies">Compañias (Seleccione una si quiere añadir productos al evento )</label>
                        <multiselect
                            v-if="companies"
                            id="companies"
                            name="companies"
                            v-model="company"
                            placeholder="Compañias"
                            track-by="id"
                            label="nombre"
                            :options="companies"
                            :max-height="150"
                            @input="fillDatos()"
                        >
                            <template slot="noOptions">No hay compañias creadas.</template>
                        </multiselect>
                    </div>
                    
                </template>                    
            </ContentOrLoading>
        </transition>
    </div>
</template>

<script>
    import ContentOrLoading from "@/components/backend/components/ContentOrLoading";

    export default {
        props: ['evento'],
        data() {
            return {
                company: this.evento.company ?? null,
                companies: null,
            }
        },
        created() {
            this.getCompanies();   
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods : {
            getCompanies() {
                const params = {
                    filters : {
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.index'), params).then(res => {
                    this.companies = res.data.data;
                    if (this.evento.productos_teatro_company_id) {
                        this.company = this.companies.find(company => company.id === this.evento.productos_teatro_company_id);
                        this.fillDatos();
                    }
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            fillDatos() {
                if (this.company) {
                    if (!this.evento.productos_teatro_company_id || this.evento.productos_teatro_company_id !== this.company.id) {
                        const data = {
                            evento_id: this.evento.id,
                            teatro_company_id: this.teatro_company_id || this.company.id, 
                            productos_teatro_company_id: this.company.id,
                            productos: 1
                        };

                        this.$store.dispatch(this.config.getVuexAlias('back.events.companies.desvincular'), {evento_id: this.evento.id, filters: { productos: 1 } })
                            .then(() => {
                                return this.$store.dispatch(this.config.getVuexAlias('back.events.companies.vincular'), data);
                            })
                            .then(res => {
                                this.$toast.success(res.data.message);
                                this.actualizar();
                            })
                            .catch(error => {
                                console.log(error);
                                this.loading = false;
                            });
                    }
                } else {
                    const data = {
                        evento_id: this.evento.id,
                        filters: {
                            productos: 1
                        },
                    };

                    this.$store.dispatch(this.config.getVuexAlias('back.events.companies.desvincular'), data)
                        .then(res => {
                            this.$toast.success(res.data.message);
                            this.actualizar();
                        })
                }
            },
            actualizar() {
                this.$emit('actualizar');
            }
        },
        components: {
            ContentOrLoading
        }
    }
</script>
